const messageTypes = ["viewing", "bought"];
  let messageIndex = 0;

  const VIEW_KEY = 'viewActivityData';
  const PURCHASE_KEY = 'purchaseActivityData';

  // ✅ Add product-specific key
  function getProductKey(baseKey) {
    const productId = window.location.pathname; // unique per product page
    return `${baseKey}_${productId}`;
  }

  function initViewingCount() {
    const stored = JSON.parse(localStorage.getItem(getProductKey(VIEW_KEY))) || {};
    const now = Date.now();

    if (!stored.startTime || now - stored.startTime > 3600000) {
      const baseCount = Math.floor(Math.random() * 26) + 25; // 25–50
      localStorage.setItem(getProductKey(VIEW_KEY), JSON.stringify({
        startTime: now,
        currentCount: baseCount
      }));
      return baseCount;
    }

    return stored.currentCount;
  }

  function incrementViewingCount() {
    let stored = JSON.parse(localStorage.getItem(getProductKey(VIEW_KEY)));
    if (!stored) return initViewingCount();

    const increment = Math.floor(Math.random() * 4) + 2;
    stored.currentCount += increment;

    if (stored.currentCount > 200) {
      stored.currentCount = Math.floor(Math.random() * 101) + 100;
      stored.startTime = Date.now();
    }

    localStorage.setItem(getProductKey(VIEW_KEY), JSON.stringify(stored));
    return stored.currentCount;
  }

  // ✅ Make "bought" random per product page
  function initPurchaseCount() {
    const stored = JSON.parse(localStorage.getItem(getProductKey(PURCHASE_KEY))) || {};
    const now = Date.now();

    if (!stored.startTime || now - stored.startTime > 86400000) {
      // generate a new random number every day
      const base = Math.floor(Math.random() * 16) + 5; // 5–20
      localStorage.setItem(getProductKey(PURCHASE_KEY), JSON.stringify({
        startTime: now,
        baseCount: base
      }));
      return base;
    }

    return stored.baseCount; // keep same for that product until reset
  }

  function getIcon(type) {
    if (type === "viewing") {
      return `
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#333" viewBox="0 0 24 24">
          <path d="M12 4.5C6.75 4.5 2.313 8.174.75 12c1.563 3.826 6 7.5 11.25 7.5S21.687 15.826 23.25 12C21.687 8.174 17.25 4.5 12 4.5Zm0 12.75a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm0-1.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>
        </svg>`;
    } else {
      return `
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#333" viewBox="0 0 24 24">
          <path d="M13 2 3 14h9l-1 8 10-12h-8z"/>
        </svg>`;
    }
  }

  function updateMessage() {
    const type = messageTypes[messageIndex];
    let number, message;

    if (type === "viewing") {
      number = incrementViewingCount();
      message = `${number} people viewing this right now.`;
    } else {
      number = initPurchaseCount();
      message = `${number} bought this in 24 hours.`;
    }

    const iconContainer = document.getElementById("icon-container");
    const messageContainer = document.getElementById("dynamic-message");

    if (iconContainer && messageContainer) {
      iconContainer.innerHTML = getIcon(type);
      messageContainer.textContent = message;
    }

    messageIndex = (messageIndex + 1) % messageTypes.length;
  }

  document.addEventListener("DOMContentLoaded", function () {
    initViewingCount();
    updateMessage();
    setInterval(updateMessage, 2000);
  });